module.exports = __webpack_public_path__ + "assets/fe79937391f2d986a6c477240569e723.mp3";